import createAPI from '@common/createAPI.js'
export default {
  // 领域列表
  postCategories: config =>
    createAPI('/api/hottopic/categories', 'post', config),
  // 地域列表
  postRegionsList: config => createAPI('/api/regions', 'post', config, {}),
  // 提取关键字、摘要
  postDocumentSyn: config =>
    createAPI('/api/document/wise/syn', 'post', config, {}),
  // 开放接口v3-获取跳转媒资库地址
  postMamUrl: config => createAPI('/api/mam/getMamUrl', 'post', config, {}),
  // 开放接口v3-查询视频音频分组
  postMamGetGroups: config =>
    createAPI('/api/mam/getGroups', 'post', config, {}),
  // 开放接口v3-查询视频下视频列表
  postVideoMembers: config =>
    createAPI('/api/mam/video/members', 'post', config, {}),
  // 开放接口v3-查询音视频列表
  postAudioMembers: config =>
    createAPI('/api/mam/listdata', 'post', config, {}),
  // 微服务接口-专题库微服务-上传
  postSpcialUpsert: config =>
    createAPI('/mbd-special/special/upsert', 'post', config, {}),
  // 文件删除
  postDeleteUpload: config =>
    createAPI('/api/delete/file', 'post', config, {
      neverLoading: true
    }),
  // 文章详情
  postSpcialDetail: config =>
    createAPI('/mbd-special/special/detail', 'post', config, {}),
  postSpcialQuery: config =>
    createAPI('/mbd-special/special/query', 'post', config, {}),
  // 数据中台-获取民族子类别列表树
  postNationList: config =>
    createAPI('/mbd-dp-manager/cat/nation', 'post', config, {}),
  // 录入单位
  postDepartmentTree: config =>
    createAPI('/api/department/limit/tree', 'post', config, {}),
  // 开放接口v3-智能审校接口
  postReviewContent: config =>
    createAPI('/api/review/content', 'post', config, {}),
  // 微服务接口-专题库微服务-审核列表查询
  postSpcialSearch: config =>
    createAPI('/mbd-special/special/search', 'post', config, {}),
  // 微服务接口-专题库微服务-删除
  postSpcialDelete: config => createAPI('/mbd-special/special/delete', 'post', config, {}),
  postSpcialCheck: config => createAPI('/mbd-special/special/check', 'post', config, {}),
  // 开放接口v3-pdf文件审校状态获取接口
  postReviewStatus: config => createAPI('/api/review/status', 'post', config, {}),
  postReviewStatusNoLoading: config => createAPI('/api/review/status', 'post', config, { neverLoading: true }),
  // 开放接口v3-PDF审校接口
  postReviewPDF: config => createAPI('/api/review/pdf', 'post', config, {}),
  // 开放接口v3-审校结果文件下载接口
  postReviewDownload: config => createAPI('/api/review/download', 'post', config, {}),
  // 开放接口v3-查询音视频接口
  postMamAISelectVideo: config => createAPI('/api/mamAi/selectVideoById', 'post', config, {}),
  // 开放接口v3-修改音视频接口
  postMamAIUpdateVideo: config => createAPI('/api/mamAi/updateVideoById', 'post', config, {}),
  // 开放接口v3-音视频检测
  postMamAICheck: config => createAPI('/api/mamAi/check', 'post', config, {}),
  // 开放接口v3-word转化为html
  postWord2html: config => createAPI('/mbd-special/special/word2html', 'get', config, {}),
  uploadImage: config => createAPI('/api/upload', 'post', config, { }), // 上传图片
  // 微服务接口-专题库微服务-全文检索
  postSpecialFtsSearch: config => createAPI('/mbd-special/special/fts/search', 'post', config, {}),
  // 开放接口v3-获取文章中图片列表
  postFindImgList: config => createAPI('/api/imageAi/findImgList', 'post', config, {}),
  // 开放接口v3-图片检测
  postImageAiCheck: config => createAPI('/api/imageAi/check', 'post', config, {}),
  // 开放接口v3-修改图片相关信息
  postImageAiUpdate: config => createAPI('/api/imageAi/updateById', 'post', config, {}),
  // 开放接口v3-查询图片详情
  postImageAiDetail: config => createAPI('/api/imageAi/detail', 'post', config, {}),
  // 数据上传中搜列表查询
  postFindUploadData: config => createAPI('/mbd-special/special/findUploadData', 'post', config, {}),
  // 专题库微服务-数据上传中搜
  postUploadXiaokangByIds: config => createAPI('/mbd-special/special/uploadXiaokangByIds', 'post', config, {}),
  // 入库量
  postStatisticArticletype: config => createAPI('/mbd-special/special/fts/statistic/distribution/articleType', 'post', config, {}),
  // 题材类型
  postStatisticDataCategory: config => createAPI('/mbd-special/special/fts/statistic/group/dataCategory', 'post', config, {}),
  // 单位排行
  postStatisticDepartmentRank: config => createAPI('/mbd-special/special/fts/statistic/group/department', 'post', config, {}),
  // 个人排行
  postStatisticPeopleRank: config => createAPI('/mbd-special/special/fts/statistic/group/user ', 'post', config, {}),
  // 主题类型
  postStatisticTopictype: config => createAPI('/mbd-special/special/fts/statistic/group/topic', 'post', config, {}),
  // 查询审校结果
  postReviewResult: config => createAPI('/mbd-special/special/review/result', 'get', config, {}),
  // 修改审校结果字段
  postReviewEditResult: config => createAPI('/mbd-special/special/review/editResult', 'post', config, {}),
  // 监管的审校=>韩冬晨负责的审校接口
  postReviewCheck: config => createAPI('/mbd-special/special/review/check', 'post', config, {}),
  // 审校类型稿件列表接口
  postStatisticsFindByReviewTypeList: config => createAPI('/mbd-special/shendu/statistics/findByReviewTypeList', 'post', config)
}
